import { type WidthSettings } from '@blaze-runtime/engine-domain';

import { DEFAULT_FIXED_WIDTH } from '../../../ai/models/styles';

import { type TableWidthStyle } from './table.definition';

export interface TablePaginationSettings {
  usePagination: boolean;
  pageSize?: number;
}

/** pageSize === undefined → scrolling list. */
export function toEnginePagination(pageSize: number | undefined): TablePaginationSettings {
  if (pageSize === undefined) {
    return { usePagination: false };
  }

  return { usePagination: true, pageSize };
}

export function toPageSize(usePagination: boolean, count: number | undefined): number | undefined {
  return usePagination ? count : undefined;
}

export function toEngineTableWidth(width: TableWidthStyle | undefined): WidthSettings {
  if (!width || width.$type === 'full') {
    return { mode: 'full' };
  }

  return { mode: 'value', value: width.width ?? DEFAULT_FIXED_WIDTH, fixed: true };
}

export function toTableWidthStyle(width: WidthSettings): TableWidthStyle | undefined {
  if (width.mode === 'full') {
    return { $type: 'full' };
  }

  if (width.mode === 'value' && width.fixed && width.value !== undefined) {
    return { $type: 'fixed', width: width.value };
  }

  return undefined;
}
